import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OktaCallbackComponent, OktaAuthGuard } from '@okta/okta-angular';

import { environment } from '../environments/environment';
import { PageNotFoundComponent } from '@pubmatic/pmcc';
import { LogoutComponent } from './pages/logout/logout.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/video-player/video-player.module').then(
      (m) => m.VideoPlayerModule
    ).catch( error => {
      console.log('An error occured ', error);
    }),
    canActivate: [ OktaAuthGuard ],
  },
  {
    path: 'analysis',
    loadChildren: () => import('./pages/publisher-analysis/publisher-analysis.module').then(
      (m) => m.PublisherAnalysisModule
    ).catch(error => {
      console.log('An error occured ', error);
    }),
    canActivate: [ OktaAuthGuard ],
  },
  {
    path: 'publisher',
    loadChildren: () => import('./pages/publisher-comparison/publisher-comparison.module').then(
      (m) => m.PublisherComparisonModule
    ).catch(error => {
      console.log('An error occured ', error);
    }),
    canActivate: [ OktaAuthGuard ],
  },
  {
    path: 'ortbValidator',
    loadChildren: () => import('./pages/ortb-validator/ortb-validator.module').then(
      (m) => m.OrtbValidatorModule
    ).catch(error => {
      console.log('An error occured ', error);
    }),
    canActivate: [ OktaAuthGuard ],
  },
  {
    path: 'testTag',
    loadChildren: () => import('./pages/test-tag/test-tag.module').then(
      (m) => m.TestTagModule
    ).catch(error => {
      console.log('An error occured ', error);
    }),
    canActivate: [ OktaAuthGuard ],
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [ OktaAuthGuard ],
  }
];

if (!environment.production) {
  // NOTE: This condition can be removed completely by applications
  routes.push({
    path: 'dashboard/app',
    redirectTo: ''
  });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
